export type EngagementTrendGranularity = "daily" | "monthly";

export type EngagementKpiMetric = {
  id: string;
  title: string;
  value: string | number;
  changePercent: number | null;
  changePercentFormatted?: string;
  format?: "number" | "percent" | "currency";
  comparisonLabel?: string;
};

export type EngagementBusinessImpactMetric = {
  id: string;
  title: string;
  value: string;
  changePercent: number | null;
  changePercentFormatted?: string;
};

export type CampaignPerformanceMetricKey =
  | "openRate"
  | "clickRate"
  | "totalSent"
  | "clickThroughRate";

export type CampaignPerformanceDatum = {
  id: string;
  label: string;
  medium: "email" | "whatsapp" | null;
  openRate: number;
  clickRate: number;
  totalSent: number;
  clickThroughRate: number;
  openRateValue: number;
  clickRateValue: number;
  totalSentValue: number;
  clickThroughRateValue: number;
  openRateFormatted?: string;
  clickRateFormatted?: string;
  totalSentFormatted?: string;
  clickThroughRateFormatted?: string;
};

export type TimeSeriesMetricKey = "openRate" | "clicks" | "bounceRate";

export type TimeSeriesDatum = {
  date: string;
  sent: number;
  opened: number;
  clicks: number;
  openRate: number;
  clickRate: number;
  clickThroughRate: number;
  bounceRate: number;
  dateFormatted?: string;
  clicksFormatted?: string;
  openRateFormatted?: string;
  bounceRateFormatted?: string;
};

export type WebsiteUsersBreakdown = {
  totalUsers: number;
  totalUsersFormatted?: string;
  slices: Array<{
    name: string;
    value: number;
    color: string;
    legendPercent?: number;
    valueFormatted?: string;
  }>;
};

export const ENGAGEMENT_CAMPAIGN_BAR_COLORS = {
  openRate: "#2b74e4",
  clickRate: "#36cdb0",
  totalSent: "#8d4fd3",
  clickThroughRate: "#f6c15f",
} as const;

export const ENGAGEMENT_TIME_SERIES_COLORS = {
  openRate: "#36cdb0",
  clicks: "#2b74e4",
  bounceRate: "#f6c15f",
} as const;

export const ENGAGEMENT_ALL_CAMPAIGNS_OPTION = "all";

export const CAMPAIGN_PERFORMANCE_METRICS: ReadonlyArray<{
  key: CampaignPerformanceMetricKey;
  label: string;
  color: string;
}> = [
  { key: "openRate", label: "Open Rate", color: ENGAGEMENT_CAMPAIGN_BAR_COLORS.openRate },
  { key: "clickRate", label: "Click Rate", color: ENGAGEMENT_CAMPAIGN_BAR_COLORS.clickRate },
  { key: "totalSent", label: "Total Sent", color: ENGAGEMENT_CAMPAIGN_BAR_COLORS.totalSent },
  {
    key: "clickThroughRate",
    label: "Click Through Rate",
    color: ENGAGEMENT_CAMPAIGN_BAR_COLORS.clickThroughRate,
  },
];

export const TIME_SERIES_METRICS: ReadonlyArray<{
  key: TimeSeriesMetricKey;
  label: string;
  color: string;
  axis: "primary" | "secondary";
}> = [
  {
    key: "openRate",
    label: "Open Rate",
    color: ENGAGEMENT_TIME_SERIES_COLORS.openRate,
    axis: "secondary",
  },
  { key: "clicks", label: "Clicks", color: ENGAGEMENT_TIME_SERIES_COLORS.clicks, axis: "primary" },
  {
    key: "bounceRate",
    label: "Bounce Rate",
    color: ENGAGEMENT_TIME_SERIES_COLORS.bounceRate,
    axis: "secondary",
  },
];

export const CAMPAIGN_PAGE_SIZE = 6;
export const KPI_PAGE_SIZE = 4;
export const TREND_PAGE_SIZE = 7;
